// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"481":"9452be20","547":"66bfa742","594":"29719518"}[chunkId] + ".js";
};